// extracted by mini-css-extract-plugin
export default {"confirm":"confirm_confirm__3dERg","actions":"confirm_actions__yUGQm"};